
<template>
  <!--添加单元-->
  <x-addEdit
    :formList="formList"
    :formKey="formKey"
    :addParam="addParam"
    :editParam="editParam"
    :detailParam="detailParam"
  >
    <template slot="gps" slot-scope="{formItem}">
      <x-location
        :form="$children[0].form"
        :inputKey="inputKey"
        :position="position"
        :lnglat="lnglat"
        :locationData="formItem">
      </x-location>
    </template>
  </x-addEdit>
</template>

<script>
import mixin from '../../../js/mixins';
export default {
  mixins: [mixin.addEdit, mixin.fetchSelect],
  name: 'addUnit',
  data () {
    let decoratorOptions = {
      community_id: {
        rules: [{ required: true, message: '请选择所属小区' }]
      },
      lng: {
        validateTrigger: 'blur',
        rules: [{ required: true, message: '请输入经度' }]
      },
      lat: {
        validateTrigger: 'blur',
        rules: [{ required: true, message: '请输入纬度' }]
      },
      building_id: {
        rules: [
          { required: true, message: '请选择楼栋' }
        ]
      },
      unit_name: {
        validateTrigger: 'blur',
        rules: [
          { required: true, message: '请输入单元名称' },
          { pattern: this.REG.name, message: '单元名称为2-20位汉字、字母、数字' }
        ]
      },
      unit_no: {
        validateTrigger: 'blur',
        rules: [
          { required: true, message: '请输入单元编号' },
          { min: 1, max: 2, message: '单元名称为1-2个字' }
        ]
      }
    };
    return {
      lnglat: '',
      position: '',
      inputKey: {
        lng: 'lng',
        lat: 'lat',
        address: 'no_address'
      },
      formList: [
        {
          label: '所属小区',
          inputType: 'select',
          options: [],
          placeholder: '请选择所属小区',
          handle: (e) => { this.communityChange(2, e, 'formList'); this.communitySelected(e); }, // 触发获取楼栋
          props: ['community_id', decoratorOptions.community_id]
        },
        {
          slot: 'gps',
          label: 'GPS定位',
          inputType: 'input',
          subList: [
            {
              inputType: 'input',
              placeholder: '经度',
              props: ['lng', decoratorOptions.lng]
            },
            {
              inputType: 'input',
              placeholder: '纬度',
              props: ['lat', decoratorOptions.lat]
            }
          ]
        },
        {
          label: '所属楼栋',
          inputType: 'select',
          options: [],
          placeholder: '请选择楼栋',
          props: ['building_id', decoratorOptions.building_id]
        },
        {
          label: '名称',
          inputType: 'input',
          options: [],
          placeholder: '请输入单元名称',
          props: ['unit_name', decoratorOptions.unit_name]
        },
        {
          label: '单元编号',
          inputType: 'input',
          options: [],
          placeholder: '请输入单元编号',
          type: 'number',
          props: ['unit_no', decoratorOptions.unit_no]
        }
      ],
      formKey: {
        community_id: '',
        lng: '',
        lat: '',
        building_id: '',
        unit_name: '',
        unit_no: ''
      },
      addParam: {
        url: '/units/add',
        reqHandle: '', // this.reqHandle
        resHandle: '' // this.addResHandle
      },
      editParam: {
        url: '/units/edit/',
        resHandle: '' // this.editResHandle
      },
      detailParam: {
        url: '/units/',
        resHandle: this.detailResHandle
      }
    };
  },
  mounted () {
    this.communitySelect(0, 'formList', 1);
  },
  methods: {
    communitySelected (val) {
      this.$children[0].form.resetFields('building_id');

      if (!val) { return; }
      let label;
      this.formList[0].options.forEach((ele) => {
        if (ele.value === val) {
          label = ele.label;
        }
      });
      let labelArr = label.split('/')[0].split(' ');
      let isCity = this.$store.state.citys.some(el => el === labelArr[0]);
      isCity ? this.position = labelArr[0] : this.position = labelArr[1];
    },
    detailResHandle (data) {
      if (data.area) {
        let area = data.area.split(' ');
        let isCity = this.$store.state.citys.some(el => el === area[0]);
        if (isCity) { // 判断是否为直辖市
          this.position = area[0];
        } else {
          this.position = area[1];
        }
      }

      this.limitEdit(data, ['community_id', 'building_id']);
      data.community_id && this.communityChange(2, data.community_id, 'formList');
      return {};
    },
    reqHandle (param) {
      console.log('处理请求前数据: ', param);
      return param;
    },
    addResHandle (res) {
      console.log('处理添加返回数据: ', res);
      return res;
    },
    editResHandle (res) {
      console.log('处理编辑返回数据: ', res);
      return res;
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/baseData/unit/addUnit.vue